import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-external",
  "use": "icon-external-usage",
  "viewBox": "0 0 14.01 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.01 10\" id=\"icon-external\"><path d=\"M1.9,5.7a.86.86,0,0,1-.6-.3.64.64,0,0,1,0-.6L2.5,1.7a.55.55,0,0,1,.6-.4H8.4a.55.55,0,0,1,.5.3.66.66,0,0,1,.1.6L7.8,5.3a.68.68,0,0,1-.6.4H6.5L6,7H7.2A2,2,0,0,0,9,5.8l1.2-3.1A1.91,1.91,0,0,0,10,.9,1.92,1.92,0,0,0,8.4,0H3.1A2,2,0,0,0,1.3,1.2L.1,4.3A2.25,2.25,0,0,0,.3,6.1,1.92,1.92,0,0,0,1.9,7H3.3l.5-1.3ZM13.7,3.9A2.2,2.2,0,0,0,12.1,3H10.7l-.5,1.3h1.9a.55.55,0,0,1,.5.3.66.66,0,0,1,.1.6L11.5,8.3a.55.55,0,0,1-.6.4H5.6a.55.55,0,0,1-.5-.3c-.2-.1-.2-.4-.1-.6L6.2,4.7a.68.68,0,0,1,.6-.4h.7L8,3H6.8A1.92,1.92,0,0,0,5,4.3l-1.2,3A2.54,2.54,0,0,0,4,9.2a2.09,2.09,0,0,0,1.6.8h5.3a2,2,0,0,0,1.8-1.2l1.2-3.1A2.25,2.25,0,0,0,13.7,3.9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/external.svg
// module id = 131
// module chunks = 0 1 2